import { __awaiter } from "tslib";
import { BaseService } from "@/servicesTs/base";
export class ApsDerivationRequestService extends BaseService() {
    static get entity() {
        return "aps_derivation_request";
    }
    static get responseName() {
        return "aps_derivation_request";
    }
    static store(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `${this.entity}`,
                data: payload,
                showFullResponse: true,
                isFullPath: true,
            });
        });
    }
    static filterManagement(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter_management`,
                data: payload,
            });
        });
    }
    static export(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `export`,
                data: payload,
                config: {
                    responseType: "blob",
                },
                showFullResponse: true,
            });
        });
    }
}
